import PageHeader from '@/components/PageHeader.vue'
import EditableSection from '@/components/EditableSection.vue'
import Panel from '@/components/Panel.vue'
import ErrorView from '@/components/ErrorView.vue'
import { VueConstructor } from 'vue'

export default {
  install(Vue: VueConstructor): void {
    Vue.component('sumi-page-header', PageHeader)
    Vue.component('sumi-editable-section', EditableSection)
    Vue.component('sumi-panel', Panel)
    Vue.component('sumi-error-view', ErrorView)
  }
}
